/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
export const Events = {
  APP_DATA: 'APP_DATA',
  AUTH_EXPIRATION: 'AUTH_EXPIRATION',
  BLOCK_NAVIGATION: 'BLOCK_NAVIGATION',
  CAN_TAKEOVER: 'CAN_TAKEOVER',
  CLICK: 'CLICK',
  COACH_MARK_POSITIONED: 'COACH_MARK_POSITIONED',
  CONFIGURE: 'CONFIGURE',
  CUSTOM_FEEDBACK: 'CUSTOM_FEEDBACK',
  CUSTOM_HELP_BUTTON_CLICK: 'CUSTOM_HELP_BUTTON_CLICK',
  CUSTOM_HERO_CLICK: 'CUSTOM_HERO_CLICK',
  CUSTOM_PROFILE_BUTTON_CLICK: 'CUSTOM_PROFILE_BUTTON_CLICK',
  CUSTOM_PROFILE_CLICK: 'CUSTOM_PROFILE_CLICK',
  CUSTOM_SEARCH: 'CUSTOM_SEARCH',
  CUSTOM_SUPPORT_TICKET_CLICK: 'CUSTOM_SUPPORT_TICKET_CLICK',
  CUSTOM_TOKEN: 'CUSTOM_TOKEN',
  DATA_FULFILL: 'DATA_FULFILL',
  DATA_REQUEST: 'DATA_REQUEST',
  DONE: 'DONE',
  EXC_PULSE: 'EXC_PULSE',
  EXC_SETTINGS: 'EXC_SETTINGS',
  FOCUS: 'FOCUS',
  GLOBAL_DIALOG_OPEN: 'GLOBAL_DIALOG_OPEN',
  HERO_CLICK: 'HERO_CLICK',
  HISTORY: 'HISTORY',
  IFRAME_RELOAD: 'IFRAME_RELOAD',
  KEYPRESS: 'KEYPRESS',
  NOT_FOUND: 'NOT_FOUND',
  NOT_INITIALIZED: 'NOT_INITIALIZED',
  NPS: 'NPS',
  OPEN_HELP_CENTER: 'OPEN_HELP_CENTER',
  PERMISSIONS: 'PERMISSIONS',
  PING: 'PING',
  PONG: 'PONG',
  QUEUE: 'QUEUE',
  READY: 'READY',
  SESSION: 'SESSION',
  SHELL_REDIRECT: 'SHELL_REDIRECT',
  SHELL_SETTINGS: 'SHELL_SETTINGS',
  SIDEBAR: 'SIDEBAR',
  SKIP_MENU_FOCUS: 'SKIP_MENU_FOCUS',
  SKIP_MENU_GET_LIST: 'SKIP_MENU_GET_LIST',
  SKIP_MENU_SET_LIST: 'SKIP_MENU_SET_LIST',
  TRIGGER_NPS: 'TRIGGER_NPS',
  USER_INPUT: 'USER_INPUT'
};

export const EventsThirdParty = {
  AUTH_EXPIRATION: 'AUTH_EXPIRATION',
  CAN_TAKEOVER: 'CAN_TAKEOVER',
  CLICK: 'CLICK',
  CONFIGURE: 'CONFIGURE',
  CUSTOM_FEEDBACK: 'CUSTOM_FEEDBACK',
  CUSTOM_HELP_BUTTON_CLICK: 'CUSTOM_HELP_BUTTON_CLICK',
  CUSTOM_HERO_CLICK: 'CUSTOM_HERO_CLICK',
  CUSTOM_SEARCH: 'CUSTOM_SEARCH',
  DATA_FULFILL: 'DATA_FULFILL',
  DATA_REQUEST: 'DATA_REQUEST',
  DONE: 'DONE',
  FOCUS: 'FOCUS',
  HERO_CLICK: 'HERO_CLICK',
  HISTORY: 'HISTORY',
  IFRAME_RELOAD: 'IFRAME_RELOAD',
  OPEN_HELP_CENTER: 'OPEN_HELP_CENTER',
  PING: 'PING',
  PONG: 'PONG',
  QUEUE: 'QUEUE',
  READY: 'READY',
  SHELL_REDIRECT: 'SHELL_REDIRECT',
  SHELL_SETTINGS: 'SHELL_SETTINGS',
  USER_INPUT: 'USER_INPUT'
};

export interface CustomMouseEvent extends MouseEvent {
  data?: any;
  fromShell?: boolean;
}

export interface CustomKeyboardEvent extends KeyboardEvent {
  data?: any;
  fromShell?: boolean;
}

export interface UserKeyEvent {
  altKey: KeyboardEvent['altKey'];
  bubbles: KeyboardEvent['bubbles'];
  ctrlKey: KeyboardEvent['ctrlKey'];
  data?: any;
  fromShell?: boolean;
  isComposing: KeyboardEvent['isComposing'];
  key: KeyboardEvent['key'];
  keyCode: KeyboardEvent['keyCode'];
  location: KeyboardEvent['location'];
  metaKey: KeyboardEvent['metaKey'];
  repeat: KeyboardEvent['repeat'];
  shiftKey: KeyboardEvent['shiftKey'];
  type: string;
}

export interface UserMouseEvent {
  data?: any;
  type: string;
}
